import React from "react";
import {
  Dialog,
  DialogContent,
  useTheme,
  useMediaQuery,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CommonMultiForm from "components/commonMultiForm/CommonMultiForm";
import "./CommonDialog.scss";

export default function CommonDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClose = () => {
    props?.handleClose();
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={props.open || false}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <Box id="responsive-dialog-title" className="mt20 iconBox">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className="iconBtnStyle"
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <DialogContent className="dialogContentStyle">
          <Grid container justifyContent="center">
            <Grid item xs={12}>
              <CommonMultiForm
                formData={props.formData}
                onSubmittBtn={props.onSubmittBtn}
                selectType={props.selectType}
                handleClose={handleClose}
                type={props.type}
                defaultValues={props?.defaultValues}
                optionData={props?.optionData}
                button={props?.button}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}
